import type { HelpFile } from '../../types/help'
import { WizardStepLaunchTestIds } from '../../../testids/WizardStepLaunchTestIds'

export const wizardStepLaunchHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [WizardStepLaunchTestIds.launchSection]:
      'Options after the policy is saved: finish without a campaign, or stage one — optionally activating it immediately.',
    [WizardStepLaunchTestIds.launchSummary]:
      'Read-only recap of the policy you just saved before you choose how to proceed.',
    [WizardStepLaunchTestIds.btnLaunchStage]:
      'Immediately create a campaign in staging status, linked to this policy and prefilled below.',
    [WizardStepLaunchTestIds.btnLaunchStageActivate]:
      'Create the campaign and immediately trigger the generation job (transitions to pending generation).',
    [WizardStepLaunchTestIds.btnFinish]:
      'Save the policy only and return to its summary page without staging a campaign.',
    [WizardStepLaunchTestIds.btnLaunchBack]: null,
    [WizardStepLaunchTestIds.launchScopeCount]: null,
    [WizardStepLaunchTestIds.launchScopeDisclaimer]: null,
    [WizardStepLaunchTestIds.launchGoToCampaign]: null,
    [WizardStepLaunchTestIds.launchNoCampaignPermission]: null,
    [WizardStepLaunchTestIds.launchOpenCampaignWarning]: null,
    [WizardStepLaunchTestIds.launchPartialFailure]: null,
    [WizardStepLaunchTestIds.launchStageError]: null,
    [WizardStepLaunchTestIds.wizardLaunchAlreadySavedNote]: null,
    [WizardStepLaunchTestIds.wizardPolicySavedBanner]: null,
  },
}
